/*
 *
 * Package: `@dbh/spin-button-theme`.
 *
 */const THEME_KEY_SPIN_BUTTON="spinButton";const modifySpinButtonTheme=a=>{let{colors:{greyUltralight:b,blackLight:c,grey:d,white:e},fonts:{size:{ff6:h},style:{medium:i}},spacing:{sp16:f,sp9:g}}=a;return {[THEME_KEY_SPIN_BUTTON]:{width:f,height:g,fontSize:h,fontWeight:i,color:d,background:e,idle:{button:{color:d,backgroundColor:b}},disabled:{button:{backgroundColor:b,color:c}}}}};

export { THEME_KEY_SPIN_BUTTON, modifySpinButtonTheme as default };
